// packages
import 'intersection-observer';
import yall from 'yall-js';

// local imports
import { AdLoader } from './ads/loader';
import { boot as bootNav } from './nav';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', () => yall());
bootNav();

// Fancy hover bits
const bigCardLinks = document.querySelectorAll(
  '.big-card-wrapper .hover-wrapper'
);
const getCardLinkSiblings = (slug) => {
  return document.querySelectorAll(`.hover-wrapper[data-slug='${slug}'] a`);
};
const bigCardMouseOver = (e) => {
  const slug = e.target.getAttribute('data-slug');
  getCardLinkSiblings(slug).forEach((e) => e.classList.add('hover'));
};
const bigCardMouseOut = (e) => {
  const slug = e.target.getAttribute('data-slug');
  getCardLinkSiblings(slug).forEach((e) => e.classList.remove('hover'));
};
bigCardLinks.forEach((e) => e.addEventListener('mouseover', bigCardMouseOver));
bigCardLinks.forEach((e) => e.addEventListener('mouseout', bigCardMouseOut));
